// MyCam 簡易模式（SPEC #mycam-617、#mycam-v1 MV16）：mycam.<brand>… 預設簡易模式，左側只剩攝影機、回放、事件、方案；可切完整模式。
// 模式只改呈現：選單項目照樣先經 visibleNav 的權限判斷，這裡只再濾掉簡易模式不放的。
import type { AppConfig } from '../../lib/appConfig';
import type { NavItem } from './nav';

export type MyCamMode = 'simple' | 'full';

export function initialMyCamMode(config: AppConfig, saved: string | null): MyCamMode {
  if (!config.mycam?.enabled || !config.mycam.active) return 'full';
  return saved === 'simple' || saved === 'full' ? saved : config.mycam.default_ui_mode;
}

export function isSimple(config: AppConfig, mode: MyCamMode): boolean {
  return !!config.mycam?.active && mode === 'simple';
}

const SIMPLE_NAV = new Set(['live', 'playback', 'events', 'billing']);

export function mycamNav(items: NavItem[], simple: boolean): NavItem[] {
  return simple ? items.filter((item) => SIMPLE_NAV.has(item.key)) : items;
}

/** 簡易模式下打開的網址不在簡易模式裡 → 換到攝影機頁（我的帳號 /settings、加入頁 /mycam 照留）。 */
export function simpleDestination(path: string): string {
  if (path === '/settings/org' || path.startsWith('/settings/org/')) return '/settings';
  return /^\/(live|playback|events|billing|settings|mycam)(\/|$)/.test(path) ? path : '/live';
}
